import { CurationClassification, CurationStatus, ImageClassification } from './types';

export const STATUS_COLOR: Record<CurationStatus, 'default' | 'info' | 'success' | 'error'> = {
  pending: 'default',
  processing: 'default',
  scored: 'info',
  failed: 'error',
};

export const CLASSIFICATION_COLOR: Record<CurationClassification, 'success' | 'warning' | 'error'> = {
  set_live: 'success',
  needs_review: 'warning',
  not_suitable: 'error',
};

export const CLASSIFICATION_LABEL: Record<CurationClassification, string> = {
  set_live: 'Set Live',
  needs_review: 'Needs Review',
  not_suitable: 'Not Suitable',
};

export const IMAGE_CLASSIFICATION_STYLE: Record<ImageClassification, { bgcolor: string; color: string }> = {
  luxury: { bgcolor: '#b8960c', color: '#fff' },
  acceptable: { bgcolor: '#71797E', color: '#fff' },
  not_luxury: { bgcolor: '#c44b2f', color: '#fff' },
  not_scored: { bgcolor: '#e0e0e0', color: '#666' },
};

export const IMAGE_CLASSIFICATION_LABEL: Record<ImageClassification, string> = {
  luxury: 'Luxury',
  acceptable: 'Acceptable',
  not_luxury: 'Not Luxury',
  not_scored: 'Not Scored',
};

export const REVIEW_DECISION_COLOR: Record<string, 'success' | 'error' | 'default'> = {
  approved: 'success',
  rejected: 'error',
};

export const REVIEW_DECISION_LABEL: Record<string, string> = {
  approved: 'Approved',
  rejected: 'Rejected',
};

export const STATUS_OPTIONS: Array<{ value: CurationStatus | ''; label: string }> = [
  { value: '', label: 'All Statuses' },
  { value: 'pending', label: 'Pending' },
  { value: 'processing', label: 'Processing' },
  { value: 'scored', label: 'Scored' },
  { value: 'failed', label: 'Failed' },
];

export const CLASSIFICATION_OPTIONS: Array<{ value: CurationClassification | ''; label: string }> = [
  { value: '', label: 'All Classifications' },
  { value: 'set_live', label: 'Set Live' },
  { value: 'needs_review', label: 'Needs Review' },
  { value: 'not_suitable', label: 'Not Suitable' },
];

export const DEFAULT_PAGE_SIZE = 50;

export const HERO_IMAGE_COUNT = 3;

export function buildImageUrl(imageServiceId: string, width = 400) {
  const host = window.configs.IMAGE_HOST;
  return `${host}/q_auto:eco,c_fill,g_auto,w_${width}/${imageServiceId}`;
}
